/* Madhukunj cart — "slot machine" digit roll on quantity change.
   Purely visual: triggers on the +/- buttons and on manual edits,
   optimistically animating to the intended value. Does not touch
   Dawn's actual cart-update logic — it fires alongside it. */
(function () {
  var ROLL_MS = 620;

  function buildSteps(oldVal, newVal) {
    if (oldVal === newVal) return [oldVal];
    var diff = newVal - oldVal;
    var absDiff = Math.abs(diff);
    var steps = [];
    if (absDiff <= 9) {
      var dir = diff > 0 ? 1 : -1;
      for (var v = oldVal; v !== newVal; v += dir) steps.push(v);
      steps.push(newVal);
      return steps;
    }
    // big jump — spin through a few pseudo-random digits, then land exactly
    steps.push(oldVal);
    for (var i = 0; i < 5; i++) steps.push(Math.floor(Math.random() * 90) + 10);
    steps.push(newVal);
    return steps;
  }

  function roll(input, oldVal, newVal) {
    if (oldVal === newVal || input.dataset.rolling === '1') return;
    var wrap = input.closest('.quantity');
    if (!wrap) return;

    input.dataset.rolling = '1';

    var rect = input.getBoundingClientRect();
    var wrapRect = wrap.getBoundingClientRect();
    var overlay = document.createElement('div');
    overlay.className = 'qty-roll';
    overlay.style.left = (rect.left - wrapRect.left) + 'px';
    overlay.style.top = (rect.top - wrapRect.top) + 'px';
    overlay.style.width = rect.width + 'px';
    overlay.style.height = rect.height + 'px';

    var track = document.createElement('div');
    track.className = 'qty-roll__track';

    var steps = buildSteps(oldVal, newVal);
    steps.forEach(function (n) {
      var d = document.createElement('div');
      d.className = 'qty-roll__digit';
      d.style.height = rect.height + 'px';
      d.textContent = n;
      track.appendChild(d);
    });

    overlay.appendChild(track);
    wrap.appendChild(overlay);

    track.style.transition = 'none';
    track.style.transform = 'translateY(0)';
    // eslint-disable-next-line no-unused-expressions
    track.offsetHeight; // force reflow so the transition below actually animates
    track.style.transition = '';
    // setTimeout instead of requestAnimationFrame — rAF gets throttled in
    // backgrounded/automated tabs, setTimeout doesn't
    setTimeout(function () {
      track.style.transform = 'translateY(-' + ((steps.length - 1) * rect.height) + 'px)';
    }, 16);

    setTimeout(function () {
      overlay.remove();
      delete input.dataset.rolling;
    }, ROLL_MS + 60);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.quantity__button');
    if (!btn) return;
    var wrap = btn.closest('.quantity');
    var input = wrap && wrap.querySelector('.quantity__input');
    if (!input) return;

    var oldVal = parseInt(input.value, 10) || 0;
    var step = parseInt(input.step, 10) || 1;
    var min = input.min !== '' ? parseInt(input.min, 10) : 0;
    var max = input.max ? parseInt(input.max, 10) : null;
    var newVal = btn.name === 'plus' ? oldVal + step : oldVal - step;
    if (newVal < min) newVal = min;
    if (max !== null && newVal > max) newVal = max;

    roll(input, oldVal, newVal);
  });

  document.addEventListener(
    'focus',
    function (e) {
      var input = e.target.closest && e.target.closest('.quantity__input');
      if (input) input.dataset.prevValue = input.value;
    },
    true
  );

  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('.quantity__input');
    if (!input) return;
    var oldVal = parseInt(input.dataset.prevValue, 10);
    var newVal = parseInt(input.value, 10);
    if (!isNaN(oldVal) && !isNaN(newVal)) roll(input, oldVal, newVal);
  });
})();
